import TriggersPage from './TriggersPage';

export default TriggersPage;